import React from 'react';
import { Link } from 'gatsby';

import { Braiins } from 'components';
import { allProducts, allAbout, allLegal, type GenericLink } from 'data/links';

import * as css from './Footer.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';

type SectionData = {
    title: NonNullable<ReactNode>;
    links: Array<GenericLink>;
};

function Section(d: SectionData) {
    return (
        <div className={css.section}>
            <div className={css.sectionTitle} children={d.title} />
            <ul
                children={d.links.map(({ url, label, external }, ind) => {
                    if (external) {
                        return (
                            <li key={ind}>
                                {/* eslint-disable-next-line gatsby/use-gatsby-link */}
                                <a href={url} target="_blank" rel="noreferrer noopener" children={label} />
                            </li>
                        );
                    }

                    return (
                        <li key={ind}>
                            <Link to={url} children={label} />
                        </li>
                    );
                })}
            />
        </div>
    );
}

export function Footer() {
    const intl = useIntl();

    return (
        <div className={css.root}>
            <Section
                title={intl.formatMessage({ defaultMessage: 'Products' })}
                links={allProducts.map(d => ({ ...d, external: true }))}
            />
            <Section title={intl.formatMessage({ defaultMessage: 'About' })} links={allAbout(intl)} />
            <Section title={intl.formatMessage({ defaultMessage: 'Legal' })} links={allLegal(intl)} />
            <div className={css.info}>
                <Braiins fill="#fff" style={{ marginBottom: 16 }} />
                <div
                    className={css.infoHead}
                    children={<FormattedMessage tagName="div" defaultMessage="Bitcoin mining tools." />}
                />
                <div
                    className={css.infoClaim}
                    children={
                        <FormattedMessage
                            tagName="div"
                            defaultMessage="Pushing the industry forward with a full-stack mining solution from mining firmware up to the pool."
                        />
                    }
                />
            </div>
        </div>
    );
}
